import axios from "axios";
import settings from "utils/settings";

const chargerUrl = `${settings.chargerUrl}api`;
const ENDPOINT = "admin/tariff";

export const requestTariffGetList = () =>
  axios.post(`${chargerUrl}/${ENDPOINT}/list`, {
    criteria: [],
  });

export const requestTariffAdd = (data) =>
  axios.post(`${chargerUrl}/${ENDPOINT}`, data);

export const requestTariffAddImage = (id, file) => {
  const formData = new FormData();
  formData.append("image", file, file.filename);
  return axios.patch(`${chargerUrl}/${ENDPOINT}/${id}/image`, formData);
};

export const requestTariffGetImage = (id) =>
  axios.get(`${chargerUrl}/${ENDPOINT}/${id}/image`, {
    responseType: "blob",
  });



// WEBPACK FOOTER //
// ./src/actions/chargers/tariff/requests.js